import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function BandsAndSigns() {
  return (
    <RulebookPage title="Bands & Signs">
      <p className="text-sm text-muted-foreground mb-3">
        Various coloured bands and symbols will be used during the game to
        communicate different effects.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Headbands &amp; Personal Markers
      </h2>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">
            Red Headband / Hand on Head
          </CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          This person does not exist within the world of the game, and is likely
          a Game Master or Crew Member. You can ask these people out of
          character questions about the game.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Pink Headband</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Noncombatant. These players may not be engaged in physical combat, and
          must immediately surrender if caught in a fight.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Blue Headband</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          This character is in the Ghost World, either as a spirit themselves,
          or using Ghost Walk or similar magic. You cannot see or interact with
          them, unless you catch their reflection in a mirror.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Arms Crossed in Front</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          This person is invisible. They cannot be seen or targeted by anyone
          who does not have a means of detecting invisible creatures.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">T-Sign</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Anyone making a T-sign with their hands is asking for a quick
          &apos;time out&apos;, where they can break character to ask GMs
          questions, or ensure other players are feeling comfortable.
        </CardContent>
      </Card>

      <hr className="my-6 border-border" />

      <h2 className="text-xl font-semibold mt-6 mb-2">Weapon Bands</h2>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Black/Brown Band</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          A black or brown band wound around the blade of a weapon means it is
          made of iron, and will do +1 damage to Fey creatures.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Silver/White Band</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          A silver or white band wound around the blade of a weapon means it is
          made of silver, and will do +1 damage to Undead creatures.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Blue Band</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          A blue band wound around the blade of a weapon means it is a Ghost
          Blade. Ghost Blades do no extra damage, but can be carried by
          characters into the Ghost World.
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Green Band</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          A green band wound around the blade of a weapon means it is poisoned.
          If a character takes damage from a poisoned weapon, they become
          Poisoned after 10 minutes, and their max HP drops to 1. This can be
          cured with a Long Rest, or by a character with the Practical Medicine
          skill.
        </CardContent>
      </Card>

      <hr className="my-6 border-border" />

      <h2 className="text-xl font-semibold mt-6 mb-2">Calls Reference</h2>

      <div className="overflow-x-auto mb-4">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr>
              <th className="text-left px-3 py-2 bg-muted font-semibold">
                Call
              </th>
              <th className="text-left px-3 py-2 bg-muted font-semibold">
                Meaning
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-3 py-2 border-t border-border">Medic</td>
              <td className="px-3 py-2 border-t border-border">
                Real-life medical emergency. Stop play, call for actual help.
              </td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-t border-border">
                Time Out (T-Sign)
              </td>
              <td className="px-3 py-2 border-t border-border">
                Brief out-of-character pause for questions or welfare check.
              </td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-t border-border">Caution</td>
              <td className="px-3 py-2 border-t border-border">
                Hazard warning — pause and move to safety before resuming.
              </td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-t border-border">Down</td>
              <td className="px-3 py-2 border-t border-border">
                Immediate full stop — take a knee. Serious emergency or safety
                issue.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Badge variant="outline">
        When in doubt, use the T-sign and ask a GM
      </Badge>
    </RulebookPage>
  );
}
